import { useDiagramTheme } from './useDiagramTheme';

export function CycleAnatomyDiagram() {
  const p = useDiagramTheme();

  return (
    <div
      className="w-full border p-5 overflow-x-auto transition-colors"
      style={{ background: p.canvasBg, borderColor: p.canvasBorder }}
    >
      <svg viewBox="0 0 700 200" className="w-full" style={{ minWidth: 520 }}>

        {/* Cycle container */}
        <rect x="10" y="10" width="680" height="180" rx="12" fill={p.indigoBg} stroke={p.indigoBorder} strokeWidth="2" />
        <text x="30" y="32" fontSize="11" fontWeight="700" fill={p.indigoText} fontFamily="sans-serif">Cycle</text>
        <text x="30" y="46" fontSize="9" fill={p.nodeSubText} fontFamily="sans-serif">Governance container · defines scope, timing, and authority structure</text>

        {/* Track Instance A */}
        <rect x="30" y="58" width="190" height="120" rx="8" fill={p.violetBg} stroke={p.violetBorder} strokeWidth="1.5" />
        <text x="125" y="76" textAnchor="middle" fontSize="10" fontWeight="700" fill={p.violetText} fontFamily="sans-serif">Track Instance A</text>
        <text x="125" y="89" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">Initiatives · Strategic altitude</text>

        <rect x="42" y="96" width="80" height="28" rx="5" fill={p.nodeBg} stroke={p.violetBorder} strokeWidth="1" />
        <text x="82" y="110" textAnchor="middle" fontSize="9" fontWeight="600" fill={p.violetText} fontFamily="sans-serif">Session</text>
        <text x="82" y="120" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">config</text>

        <rect x="130" y="96" width="80" height="28" rx="5" fill={p.nodeBg} stroke={p.violetBorder} strokeWidth="1" />
        <text x="170" y="110" textAnchor="middle" fontSize="9" fontWeight="600" fill={p.violetText} fontFamily="sans-serif">Session</text>
        <text x="170" y="120" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">ranking</text>

        <rect x="42" y="133" width="168" height="34" rx="5" fill={p.violetBg} stroke={p.violetBorder} strokeWidth="1" />
        <text x="126" y="149" textAnchor="middle" fontSize="9" fontWeight="600" fill={p.violetText} fontFamily="sans-serif">Session Results</text>
        <text x="126" y="161" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">Immutable ranked output</text>

        {/* Track Instance B */}
        <rect x="255" y="58" width="190" height="120" rx="8" fill={p.violetBg} stroke={p.violetBorder} strokeWidth="1.5" />
        <text x="350" y="76" textAnchor="middle" fontSize="10" fontWeight="700" fill={p.violetText} fontFamily="sans-serif">Track Instance B</text>
        <text x="350" y="89" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">Features · Team altitude</text>

        <rect x="267" y="96" width="80" height="28" rx="5" fill={p.nodeBg} stroke={p.violetBorder} strokeWidth="1" />
        <text x="307" y="110" textAnchor="middle" fontSize="9" fontWeight="600" fill={p.violetText} fontFamily="sans-serif">Session</text>
        <text x="307" y="120" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">config</text>

        <rect x="355" y="96" width="80" height="28" rx="5" fill={p.nodeBg} stroke={p.violetBorder} strokeWidth="1" />
        <text x="395" y="110" textAnchor="middle" fontSize="9" fontWeight="600" fill={p.violetText} fontFamily="sans-serif">Session</text>
        <text x="395" y="120" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">ranking</text>

        <rect x="267" y="133" width="168" height="34" rx="5" fill={p.violetBg} stroke={p.violetBorder} strokeWidth="1" />
        <text x="351" y="149" textAnchor="middle" fontSize="9" fontWeight="600" fill={p.violetText} fontFamily="sans-serif">Session Results</text>
        <text x="351" y="161" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">Immutable ranked output</text>

        {/* Catchball column */}
        <rect x="480" y="58" width="190" height="120" rx="8" fill={p.amberBg} stroke={p.amberBorder} strokeWidth="1.5" />
        <text x="575" y="76" textAnchor="middle" fontSize="10" fontWeight="700" fill={p.amberText} fontFamily="sans-serif">Catchball Loops</text>
        <text x="575" y="89" textAnchor="middle" fontSize="8" fill={p.nodeSubText} fontFamily="sans-serif">Authority choreography</text>

        <rect x="492" y="96" width="166" height="26" rx="5" fill={p.nodeBg} stroke={p.amberBorder} strokeWidth="1" />
        <text x="575" y="113" textAnchor="middle" fontSize="9" fill={p.amberText} fontFamily="sans-serif">Loop 1: Request → Propose</text>

        <rect x="492" y="129" width="166" height="26" rx="5" fill={p.nodeBg} stroke={p.amberBorder} strokeWidth="1" />
        <text x="575" y="146" textAnchor="middle" fontSize="9" fill={p.amberText} fontFamily="sans-serif">Loop 2: Revise → Accept</text>

        <rect x="492" y="159" width="166" height="10" rx="5" fill={p.amberBg} stroke={p.amberBorder} strokeWidth="1" />
        <text x="575" y="167" textAnchor="middle" fontSize="8" fill={p.amberText} fontFamily="sans-serif">→ Ratify → Publish</text>
      </svg>
      <p className="text-center text-xs mt-1" style={{ color: p.canvasText }}>
        A cycle contains multiple parallel track instances, each with their own sessions and results
      </p>
    </div>
  );
}
